import React from 'react';
import './Clube.css';
import * as generic from './generic.js';

export default function Clube(props) {
	const clube = props.clubeMap && props.clubeMap[props.clube];
	if (!clube) {
		return <div onClick={props.onClick} className={"clube " + props.className} style={props.onClick ? { "cursor": "pointer" } : null}><span className="nome">&nbsp;</span></div>;
	}
	return (
		<div onClick={props.onClick} className={"clube " + props.className} title={clube.name} style={props.onClick ? { "cursor": "pointer" } : null}>
			<span className="nome">{clube.name}</span>
			<span className="nome_abr">{clube.name_short}</span>
			<span className="nome_suffix">{clube.suffix}</span>
			<img alt="" className="escudo" src={generic.baseUrl + clube.escudo}/>
		</div>
	);
}
